import React, { useMemo } from 'react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';

import { StyledStepConnector } from 'features/dashboard/components/StyledStepConnector';
import { StepIcon } from 'features/dashboard/components/StepIcon';
import { useTranslation } from 'hooks/useTranslation';

import { useStyles } from './styles';
import i18n from 'locales/i18n';

interface SendGiftStepperProps {
  onStepClick: (step: number, completed: boolean) => void;
  passedSteps: number[];
}

export const SendGiftStepper = ({ onStepClick, passedSteps }: SendGiftStepperProps) => {
  const direction = i18n.dir()

  const classes = useStyles({ direction });
  const { t } = useTranslation('dashboard');

  const steps = useMemo(() => [t('personalInformation'), t('giftInformation'), t('reviewDetails')], [t]);

  return (
    <div className={classes.root}>
      <Stepper className={classes.stepper} activeStep={passedSteps.length + 1} alternativeLabel connector={<StyledStepConnector />}>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={StepIcon(index, onStepClick)}>
              <Typography className={classes.stepLabel}>{label}</Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};
